import { render, staticRenderFns } from "./RetailFMCGAdvantage.vue?vue&type=template&id=6ae82f0b&"
import script from "./RetailFMCGAdvantage.vue?vue&type=script&lang=js&"
export * from "./RetailFMCGAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports